import OutlinedInput from "@mui/material/OutlinedInput";
import { forwardRef, useEffect, useState } from "react";

export const DATE_MODE = {
  DATE:  {ID: 1, TYPE: "date",  MIN_DEF: "1000-01-01", MAX_DEF: "9999-12-31"},
  MONTH: {ID: 2, TYPE: "month", MIN_DEF: "1900-01",    MAX_DEF: "2999-12"}
};

export const DATE_STR_START = 0;
export const YEAR_STR_END   = 4;
export const MONTH_STR_END  = 7;
export const DATE_STR_END   = 10;

const DateInput = forwardRef(({
  value,
  setValue,
  onChange,
  mode = DATE_MODE.DATE,
  maxDate = mode.MAX_DEF,
  minDate = mode.MIN_DEF,
  ...props
}, ref) => {
  const [valueInput, setValueInput] = useState(value ? value : "");

  useEffect(() => {
    setValueInput(value ? value : "");
  }, [value]);

  const handleChange = (event) => {
    setValueInput(event.target.value);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const handleBlur = (event) => {
    setValueInput(event.target.value);
    if (setValue) {
      setValue(event.target.value);
    }
  };

  return (
    <OutlinedInput
      {...props}
      type={mode.TYPE}
      value={valueInput}
      onChange={handleChange}
      onBlur={handleBlur}
      ref={ref}
      inputProps={{
        min: minDate,
        max: maxDate,
      }}
    />
  );
});

export default DateInput;
